import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import router from '../router'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin )



axios.interceptors.request.use(config => {


let encryptToken = sessionStorage.getItem('encryptToken')

if (encryptToken && encryptToken != "undefined") {  // 判断是否存在token，如果存在的话，则每个http header都加上token

config.headers.common['token'] = sessionStorage.getItem('encryptToken');
}

console.log()
let apiurlstr = config.url
let apistr = apiurlstr.substr(apiurlstr.lastIndexOf("/" )+1)
if(apistr == 'updateCurrentTime'||apistr == 'login'||apistr == 'queryOrder'){

}else {
Vue.$vux.loading.show({
text:"请稍后"
})
}

return config
}, error => {
return Promise.reject(error)
})

axios.interceptors.response.use(response => {
return response
}, error => {
return Promise.resolve(error.response)
})

function checkStatus (response) {

console.log(response)

if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {

if(response.data.code == 'A1001'||response.data.code == '404'){
if( Vue.$cookies.get('category')=='msb'){



Vue.$cookies.set("msbToken", '')


router.replace({ path: '/msb/home?commercialNumber='+Vue.$cookies.get('commercialNumber')})

}
}

return response


}

return {
status: -404,
msg: '网络异常'
}
}

function checkCode (res) {
Vue.$vux.loading.hide()

if (res.status === -404) {
Vue.$vux.toast.show({
type: "text",
text: res.msg

})
}
return res
}




axios.defaults.baseURL = 'http://unionapi.allinpaynmg.com/api';

export default {
get (url, params) {
return axios({
method: 'get',
url,
params,// get 请求时带的参数
timeout: 180000,
headers: {
'X-Requested-With': 'XMLHttpRequest',

}
}).then(
(response) => {
return checkStatus(response)
}
).then(
(res) => {
return checkCode(res)
}
)
},
post (url, data) {
return axios({
method: 'post',
url,
data: qs.stringify(data),
timeout: 180000,
dataType: 'json',
headers: {
'X-Requested-With': 'XMLHttpRequest',
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
}).then(
(response) => {
console.log(response)
return checkStatus(response)
}
).then(
(res) => {
return checkCode(res)
}
)
},
postjson (url, data) {
return axios({
method: 'post',
url,
data:data,
timeout: 180000,
dataType: 'json',
headers: {
'Content-Type': 'application/json'
}
}).then(
(response) => {
console.log(response)
return checkStatus(response)
}
).then(
(res) => {
return checkCode(res)
}
)
},
delete (url, params) {
return axios({
method: 'delete',
url,
params,
timeout: 180000,
headers: {
'X-Requested-With': 'XMLHttpRequest',
'token':sessionStorage.getItem('encryptToken')
}
}).then(
(response) => {
console.log(response)
return checkStatus(response)
}
).then(
(res) => {
return checkCode(res)
}
)
},
upload (url, data) {
return axios({
method: 'post',
url,
data: data,
timeout: 180000,
dataType: 'json',
headers: {
'X-Requested-With': 'XMLHttpRequest',
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
}).then(
(response) => {

return checkStatus(response)
}
).then(
(res) => {
return checkCode(res)
}
)
},

baeurlWeb:"http://unionapi.allinpaynmg.com"
}



// WEBPACK FOOTER //
// ./src/api/api.js